// extracted by mini-css-extract-plugin
export default {"wrapper":"vIxrPbceuJinXJmiRbi4","borderless":"AgtfEeTsGmAAmh6B4XLR"};